module.exports = __webpack_public_path__ + "static/media/IDLC---Eid-Card-Design_Final.2ded88fa.png";